import { styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React from 'react';

const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'var(--surface-secondary)',
      color: 'var(--text-primary)',
      maxWidth: 800,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid var(--border-default)',
    },
  }),
);

export default HtmlTooltip;
